import { render, staticRenderFns } from "./CourseTable.vue?vue&type=template&id=54194a1c&scoped=true"
import script from "./CourseTable.vue?vue&type=script&lang=js"
export * from "./CourseTable.vue?vue&type=script&lang=js"
import style0 from "./CourseTable.vue?vue&type=style&index=0&id=54194a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54194a1c",
  null
  
)

export default component.exports